import { render, staticRenderFns } from "./onboarding-tour.vue?vue&type=template&id=e3c567de&scoped=true"
import script from "./onboarding-tour.vue?vue&type=script&lang=js"
export * from "./onboarding-tour.vue?vue&type=script&lang=js"
import style0 from "./onboarding-tour.vue?vue&type=style&index=0&id=e3c567de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c567de",
  null
  
)

export default component.exports